export const MODULES = {
  hero: 'hero',
  careerOutcomes: 'career_outcomes',
  programDetails: 'program_details',
  stackability: 'stackability',
  faqs: 'faqs',
} as const;

export type ModuleKey = (typeof MODULES)[keyof typeof MODULES];

const MODULE_KEYS = new Set<string>(Object.values(MODULES));

const isModuleKey = (value: string | null | undefined): value is ModuleKey => !!value && MODULE_KEYS.has(value);

export const DEFAULT_MODULE_ORDER: ModuleKey[] = [
  MODULES.hero,
  MODULES.careerOutcomes,
  MODULES.programDetails,
  MODULES.stackability,
  MODULES.faqs,
];

type ContentfulModuleOrderItems = ReadonlyArray<{ module?: string | null } | null> | undefined;

/**
 * Orders modules as Contentful lists them, ignoring unknown names and duplicates.
 * Modules Contentful leaves out are appended in the default order.
 */
export const resolveModuleOrder = (items: ContentfulModuleOrderItems): ModuleKey[] => {
  const contentfulOrder = (items ?? []).map((item) => item?.module).filter(isModuleKey);
  return Array.from(new Set([...contentfulOrder, ...DEFAULT_MODULE_ORDER]));
};
